<template>
  <v-navigation-drawer
    :rail="isCollapsed"
    permanent
    :color="mainColour"
    floating
    elevation="0"
    :width="220"
  >
    <v-list density="compact" nav>
      <v-list-item
        v-for="item in visibleNavItems"
        :key="item.value"
        :prepend-icon="item.icon"
        :title="item.title"
        :value="item.value"
        @click="$emit('navigate', { value: item.value, version: item.version })"
      ></v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="d-flex justify-center">
        <v-btn
          :icon="isDarkTheme ? 'mdi-white-balance-sunny' : 'mdi-weather-night'"
          variant="text"
          @click="toggleTheme"
        ></v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script setup>
import { computed } from 'vue';
import { useTheme } from 'vuetify';

const props = defineProps({
  isCollapsed: {
    type: Boolean,
    default: false,
  },
  isMechanic: {
    type: Boolean,
    default: false,
  },
  isAdmin: {
    type: Boolean,
    default: false,
  },
  isLocalDev: {
    type: Boolean,
    default: false,
  },
  features: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(['navigate']);

const theme = useTheme();

const allNavItems = [
  { title: 'Home', icon: 'mdi-home', value: 'home', version: '' },

  { title: 'Vehicles & Trailers', icon: 'mdi-truck-outline', value: 'vehicles', requiresRole: 'mechanic', requiresFeature: 'vehicles', version: 'v3'},
  { title: 'Equipment', icon: 'mdi-excavator', value: 'equipment', requiresRole: 'mechanic', requiresFeature: 'equipment', version: 'v3' },
  { title: 'Inspections', icon: 'mdi-clipboard-check-outline', value: 'inspections', requiresRole: 'mechanic', requiresFeature: 'inspections', version: 'v3' },
  { title: 'Checklists', icon: 'mdi-format-list-checks', value: 'checklists', requiresRole: 'mechanic', requiresFeature: 'checklists', version: 'v3' },
  { title: 'Reports', icon: 'mdi-file-chart-outline', value: 'reports', requiresRole: 'mechanic', requiresFeature: 'inspections', version: 'v3' },

  { title: 'Whats New?', icon: 'mdi-new-box', value: 'whatsnew', requiresRole: 'default', version: '' },
  { title: 'Map', icon: 'mdi-map-marker-outline', value: 'map', requiresRole: 'default', requiresFeature: 'tracking', version: '' },
  { title: 'Compliance', icon: 'mdi-shield-check-outline', value: 'compliance', requiresRole: 'default', requiresFeature: 'compliance', version: '' },
  { title: 'Vehicles & Trailers', icon: 'mdi-truck-outline', value: 'vehicles', requiresRole: 'default', requiresFeature: 'vehicles', version: 'v3' },
  { title: 'Equipment', icon: 'mdi-excavator', value: 'equipment', requiresRole: 'default', requiresFeature: 'equipment', version: 'v3' },
  { title: 'Inspections', icon: 'mdi-clipboard-check-outline', value: 'inspections', requiresRole: 'default', requiresFeature: 'inspections', version: 'v3' },
  { title: 'Hours of Service', icon: 'mdi-clock-outline', value: 'hours', requiresRole: 'default', requiresFeature: 'timesheets', version: 'v3' },
  { title: 'Users', icon: 'mdi-account-group-outline', value: 'users', requiresRole: 'default', version: 'v3' },
  { title: 'Checklists', icon: 'mdi-format-list-checks', value: 'checklists', requiresRole: 'default', requiresFeature: 'checklists', version: 'v3' },
  { title: 'Reports', icon: 'mdi-file-chart-outline', value: 'reports', requiresRole: 'default', requiresFeature: 'inspections', version: 'v3' },
  { title: 'Invoices', icon: 'mdi-receipt-text-outline', value: 'invoices', requiresRole: 'default', version: 'v3' },
  { title: 'Billing', icon: 'mdi-credit-card-outline', value: 'billing/display', requiresRole: 'default', version: 'v3' },
  { title: 'Company', icon: 'mdi-domain', value: 'company/display', requiresRole: 'default', version: '' },
    
  { title: 'Admin', icon: 'mdi-shield-account-outline', value: 'admin', requiresRole: 'admin', version: '' },
  { title: 'Dashboard', icon: 'mdi-developer-board', value: 'dashboard', requiresRole: 'dev', version: 'v3' },
];

const visibleNavItems = computed(() => {
  return allNavItems.filter(item => {
    if (item.requiresRole === 'mechanic' && !props.isMechanic) return false;
    if (item.requiresRole === 'default' && props.isMechanic) return false;
    if (item.requiresRole === 'admin' && !props.isAdmin) return false;
    if (item.requiresRole === 'dev' && !props.isLocalDev) return false;

    if (item.requiresFeature && !props.features[item.requiresFeature]) {
      return false;
    }

    return true;
  });
});

const mainColour = computed(() => {
  return theme.global.name.value === 'dark' ? 'grey-darken-4' : 'grey-lighten-4';
});

const isDarkTheme = computed(() => theme.global.name.value === 'dark');

function toggleTheme() {
  theme.global.name.value = theme.global.name.value === 'dark' ? 'light' : 'dark';
}

</script>

